// ProfileContainer.js
import React, { useEffect, useRef, useState } from 'react';
import {jwtDecode} from 'jwt-decode';
import ProfileSidebar from '../../components/profile/ProfileSidebar';
import ProfileSection from '../../components/profile/ProfileSection';
import LoginDetailsSection from '../../components/profile/LoginDetailsSection';
import OrderHistorySection from '../../components/profile/OrderHistorySection';
import PaymentMethodsSection from '../../components/profile/PaymentMethodsSection'; // Import the new PaymentMethodsSection
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const [userDetails, setUserDetails] = useState({ name: '', email: '', phone_number: '', address: '', pincode: '', state: '' });
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editableDetails, setEditableDetails] = useState({});
  const [activeSection, setActiveSection] = useState('profile');
  
  const profileRef = useRef(null);
  const loginDetailsRef = useRef(null);
  const orderHistoryRef = useRef(null);
  const paymentMethodsRef = useRef(null); // New ref for Payment Methods section
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('google_token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        let sub = decodedToken.sub;
        if (typeof sub === 'string') {
          sub = JSON.parse(sub);
        }

        setUserDetails({
          name: sub.username || 'Guest',
          email: sub.email_id || '',
          phone_number: sub.phone_number || '',
        });
      } catch (error) {
        console.error('Error decoding token:', error);
      }
    }
    setLoading(false);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    setUserDetails((prev) => ({ ...prev, ...editableDetails }));
    setIsEditing(false);
  };

  const handleSectionChange = (section) => {
    setActiveSection(section);
    const sectionRef = 
      section === 'profile' ? profileRef :
      section === 'loginDetails' ? loginDetailsRef :
      section === 'orderHistory' ? orderHistoryRef :
      paymentMethodsRef; // Set to paymentMethodsRef if section is "paymentMethods"
      
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (loading) return <p>Loading user details...</p>;

  return (
    <div className="flex h-full bg-gray-50 p-4">
      <ProfileSidebar
        activeSection={activeSection}
        handleSectionChange={handleSectionChange}
        handleSignOut={() => navigate('/login')}
      />
      
      <div className="w-4/5 p-4 space-y-8">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 text-gray-600 hover:text-blue-500 flex items-center transition-all"
        >
          <FiArrowLeft className="mr-2" size={20} />
          <span>Back</span>
        </button>

        {/* Profile Section */}
        <div ref={profileRef}>
          <ProfileSection
            userDetails={userDetails}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            editableDetails={editableDetails}
            handleInputChange={handleInputChange}
            handleSave={handleSave}
          />
        </div>

        {/* Login Details Section */}
        <div ref={loginDetailsRef}>
          <LoginDetailsSection userDetails={userDetails} activeSection={activeSection} />
        </div>

        {/* Order History Section */}
        <div ref={orderHistoryRef}>
          <OrderHistorySection userDetails={userDetails} activeSection={activeSection} />
        </div>

        {/* Payment Methods Section */}
        <div ref={paymentMethodsRef}>
          <PaymentMethodsSection userDetails={userDetails} activeSection={activeSection} />
        </div>
      </div>
    </div>
  );
};

export default Profile;
